import { Controller } from "@hotwired/stimulus"
import consumer from './../channels';
import $ from 'jquery'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = [
    "form",
    "submitButton",
    "queries",
    "results",
    "refreshButton",
    "sqlInput",
    "targetsInput",
    "intervalButton",
    "confirmButton",
    "resultsTab",
    "statusTab",
    "writeWithAiButton",
    "aiChatPanel",
    "aiChatOverlay",
    "aiChatInput",
    "aiChatBody",
    "aiChatSendButton",
    "aiChatEmptyState",
    "aiChatHistory",
    "aiChatHistoryList",
    "aiChatNewButton",
  ];

  static values = {
    campaignId: String,
    dtEnabled: Boolean,
    conversationId: String,
    conversationUrl: String,
    conversationsIndexUrl: String,
  };

  loader = `<div class="render-async"><div class="spinner"></div></div>`
  stateClean = true;
  _emptyStateHtml = null;

  connect() {
    if (this.hasAiChatEmptyStateTarget) {
      this._emptyStateHtml = this.aiChatEmptyStateTarget.outerHTML;
    }

    if (this.hasCampaignIdValue) {
      this.liveQueryQueriesSubscription = consumer.subscriptions.create(
        { channel: "LiveQueryCampaignQueriesChannel", campaign_id: this.campaignIdValue, dt_enabled: this.dtEnabledValue },
        {
          received(data) {
            let tr = `tr[data-live-query-id='${data.query_id}']`
            let tableClass = ".live-query-editor__queries .live-queries__data-table"
            if (parseInt($(`.live-query-editor__queries tr[data-live-query-id='${data.query_id}']`).attr("data-live-query-status")) <= data.status) {
              $(tableClass).DataTable().rows(tr).remove()
              $(`.live-query-editor__queries tr[data-live-query-id='${data.query_id}']`).prop('outerHTML', data.row)
            }
          },
        },
      );

      this.liveQueryResultsSubscription = consumer.subscriptions.create(
        { channel: "LiveQueryCampaignResultsChannel", campaign_id: this.campaignIdValue, dt_enabled: this.dtEnabledValue },
        {
          received: (data) => {
            // Update if no results are on screen
            if ($('.live-queries__with-results:visible').length > 0) {
              $(this.refreshButtonTarget).show()
            } else {
              // Otherwise just show the refresh button
              $(this.resultsTarget).html(data)
            }
          },
        },
      );

      this.bindFormListeners();
    }
  }

  clear() {
    $(this.queriesTarget).html(this.loader)
    $(this.resultsTarget).html(this.loader)
    $(this.formTarget).find("span.error").remove()
    this.stateClean = true;
  }

  clearResults() {
    $(this.resultsTarget).html(this.loader)
  }

  viewResult() {
    window.addEventListener("turbo:before-stream-render", () => {
      this.resultsTabTarget.click();
    }, { once: true });
  }

  reloadResultsTable() {
    let tableClass = ".live-query-editor__results .live-queries__data-table"
    $(tableClass).DataTable().ajax.reload()
    event.preventDefault()
  }

  bindFormListeners() {
    if (this.hasSqlInputTarget) {
      this.sqlInputTarget.addEventListener('change', this.handleFormChange)
    }

    if (this.hasTargetsInputTarget) {
      this.targetsInputTarget.addEventListener('change', this.handleFormChange)
    }
  }

  handleFormChange = () => {
    if (this.stateClean && this.hasIntervalButtonTarget && this.hasConfirmButtonTarget) {
      $(this.intervalButtonTarget).toggleClass("hidden");
      $(this.confirmButtonTarget).toggleClass("hidden");
      this.stateClean = false;
    }
  }

  ensureNlqSubscription() {
    if (this.nlqSubscription) return;

    this.nlqSubscription = consumer.subscriptions.create(
      { channel: "NlqConversationChannel" },
      {
        received: (data) => {
          if (this.conversationIdValue && String(data.conversation_id) === this.conversationIdValue) {
            this.handleNlqReceived(data);
          }
          this.fetchConversationHistory();
        },
      }
    );
  }

  disconnect() {
    this.clearNlqTimers();
    if (this.nlqSubscription) {
      this.nlqSubscription.unsubscribe();
      this.nlqSubscription = null;
    }
    if (typeof this.liveQueryQueriesSubscription !== 'undefined') {
      this.liveQueryQueriesSubscription.unsubscribe();
    }

    if (typeof this.liveQueryResultsSubscription !== 'undefined') {
      this.liveQueryResultsSubscription.unsubscribe();
    }
  }

  handleNlqReceived(data) {
    this.clearNlqTimers();
    this.setLoading(false);
    this.setSendEnabled(true);
    if (data.error) {
      this.renderErrorMessage(data.error);
    } else if (data.message) {
      if (data.conversation_id && !this.conversationIdValue) {
        this.conversationIdValue = data.conversation_id;
      }
      this.renderAssistantMessage(data.message);
    }
  }

  clearNlqTimers() {
    if (this.nlqSafetyTimer) {
      clearTimeout(this.nlqSafetyTimer);
      this.nlqSafetyTimer = null;
    }
    if (this.nlqStillWorkingTimer) {
      clearTimeout(this.nlqStillWorkingTimer);
      this.nlqStillWorkingTimer = null;
    }
  }

  startNlqTimers() {
    this.nlqStillWorkingTimer = setTimeout(() => {
      this.updateLoadingText("Still working on your query...");
    }, 10000);
    this.nlqSafetyTimer = setTimeout(() => {
      this.clearNlqTimers();
      this.setLoading(false);
      this.setSendEnabled(true);
      this.renderErrorMessage("This is taking longer than expected. Please try again.");
    }, 90000);
  }

  updateLoadingText(text) {
    if (!this.hasAiChatBodyTarget) return;
    const loadingEl = this.aiChatBodyTarget.querySelector(".ai-chat-message--loading");
    if (loadingEl) {
      const bubble = loadingEl.querySelector(".ai-chat-message__bubble");
      if (bubble) {
        bubble.innerHTML = `<span class="ai-chat-loading-dots"><span></span><span></span><span></span></span><p class="ai-chat-message__still-working">${this.escapeHtml(text)}</p>`;
      }
    }
  }

  submitForm(event) {
    // command-enter or ctrl-enter submits the form
    if ((event.ctrlKey || event.metaKey) && event.which == 13) {
      event.preventDefault();
      this.submitButtonTarget.click()
    }
  }

  // --- AI Chat Panel ---

  async openAiChat(event) {
    event.preventDefault();
    if (this.hasAiChatPanelTarget) {
      this.aiChatPanelTarget.classList.add("ai-chat-panel--open");
      this.aiChatOverlayTarget.classList.add("ai-chat-overlay--visible");
      document.body.style.overflow = "hidden";
      this.ensureNlqSubscription();
      const conversations = await this.fetchConversationHistory();

      if (!this.conversationIdValue) {
        const active = conversations?.find(c => c.status === "active");
        if (active) {
          await this.loadConversationById(active.id);
        } else {
          this.prependUntitledEntry();
        }
      }

      if (this.hasAiChatInputTarget) {
        setTimeout(() => this.aiChatInputTarget.focus(), 300);
      }
    }
  }

  closeAiChat(event) {
    event.preventDefault();
    if (this.hasAiChatPanelTarget) {
      this.aiChatPanelTarget.classList.remove("ai-chat-panel--open");
      this.aiChatOverlayTarget.classList.remove("ai-chat-overlay--visible");
      document.body.style.overflow = "";
    }
  }

  handleAiChatKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.submitMessage();
    }
  }

  fillExamplePrompt(event) {
    event.preventDefault();
    const prompt = event.currentTarget.dataset.prompt;
    if (this.hasAiChatInputTarget && prompt) {
      this.aiChatInputTarget.value = prompt;
      this.aiChatInputTarget.focus();
    }
  }

  async submitMessage() {
    if (this.hasAiChatSendButtonTarget && this.aiChatSendButtonTarget.disabled) return;

    const message = this.aiChatInputTarget.value.trim();
    if (!message) return;

    this.aiChatInputTarget.value = "";
    this.hideEmptyState();
    this.renderUserMessage(message);
    this.setLoading(true);
    this.setSendEnabled(false);

    const url = this.conversationIdValue
      ? `${this.conversationUrlValue}/${this.conversationIdValue}/ask`
      : this.conversationUrlValue;

    const payload = {
      message,
      target_groups: this.getSelectedTargetGroups(),
      existing_sql: this.hasSqlInputTarget ? this.sqlInputTarget.value : null,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": Rails.csrfToken(),
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        this.setLoading(false);
        this.setSendEnabled(true);
        let errorMsg = "Something went wrong. Please try again.";
        try {
          const data = await response.json();
          if (data.error) errorMsg = data.error;
        } catch { /* non-JSON error response */ }
        this.renderErrorMessage(errorMsg);
        return;
      }

      const data = await response.json();

      if (data.conversation_id) {
        this.conversationIdValue = data.conversation_id;
        this.fetchConversationHistory();
      }

      this.ensureNlqSubscription();
      this.startNlqTimers();
    } catch (error) {
      this.setLoading(false);
      this.setSendEnabled(true);
      this.renderErrorMessage("Network error. Please check your connection and try again.");
    }
  }

  useQuery(event) {
    event.preventDefault();
    const sql = event.currentTarget.dataset.sql;
    if (!sql) return;

    this.closeAiChat(event);

    if (this.hasSqlInputTarget) {
      this.sqlInputTarget.value = sql;
      const changeEvent = new Event('change', { bubbles: true });
      this.sqlInputTarget.dispatchEvent(changeEvent);
    }

    const editorEl = this.element.querySelector('[data-controller~="kolide-editor"]');
    if (editorEl?.monacoEditor) {
      requestAnimationFrame(() => {
        editorEl.monacoEditor.setValue(sql);
        editorEl.monacoEditor.layout();
      });
    }
  }

  // --- AI Chat rendering helpers ---

  hideEmptyState() {
    if (this.hasAiChatEmptyStateTarget) {
      this.aiChatEmptyStateTarget.style.display = "none";
    }
  }

  renderUserMessage(text) {
    if (!this.hasAiChatBodyTarget) return;
    const div = document.createElement("div");
    div.className = "ai-chat-message ai-chat-message--user";
    div.innerHTML = `<div class="ai-chat-message__bubble">${this.escapeHtml(text)}</div>`;
    this.aiChatBodyTarget.appendChild(div);
    this.scrollChatToBottom();
  }

  renderAssistantMessage(msg) {
    if (!this.hasAiChatBodyTarget || !msg) return;

    // Denials and system errors are not answers — never render them as a
    // clarifying-question bubble that invites another (counted) reply.
    if (msg.kind && msg.kind !== "llm_response") {
      this.renderNoticeMessage(msg);
      return;
    }

    const div = document.createElement("div");
    div.className = "ai-chat-message ai-chat-message--assistant";

    let html = "";
    if (msg.clarifying_question) {
      html += `<p class="ai-chat-message__explanation">${this.escapeHtml(msg.clarifying_question)}</p>`;
    } else if (msg.platform_queries?.length) {
      msg.platform_queries.forEach((pq) => {
        html += `<div class="ai-chat-message__platform-query">`;
        html += `<p class="ai-chat-message__platform-label">${this.escapeHtml(pq.platform)}</p>`;
        if (pq.explanation) {
          html += `<p class="ai-chat-message__explanation">${this.escapeHtml(pq.explanation)}</p>`;
        }
        html += `<div class="ai-chat-message__sql-block">`;
        html += `<pre class="ai-chat-message__sql"><code>${this.escapeHtml(pq.sql)}</code></pre>`;
        html += `<button class="ai-chat-message__use-query" data-action="click->live-query#useQuery" data-sql="${this.escapeAttr(pq.sql)}">Use this query</button>`;
        html += `</div></div>`;
      });
    } else {
      if (msg.explanation) {
        html += `<p class="ai-chat-message__explanation">${this.escapeHtml(msg.explanation)}</p>`;
      }
      if (msg.sql) {
        html += `<div class="ai-chat-message__sql-block">`;
        html += `<pre class="ai-chat-message__sql"><code>${this.escapeHtml(msg.sql)}</code></pre>`;
        html += `<button class="ai-chat-message__use-query" data-action="click->live-query#useQuery" data-sql="${this.escapeAttr(msg.sql)}">Use this query</button>`;
        html += `</div>`;
      }
      if (msg.valid === false && msg.errors?.length) {
        html += `<p class="ai-chat-message__validation-error">Warning: ${this.escapeHtml(msg.errors.join(", "))}</p>`;
      }
    }

    div.innerHTML = `<div class="ai-chat-message__bubble">${html}</div>`;
    this.aiChatBodyTarget.appendChild(div);
    this.scrollChatToBottom();
  }

  renderErrorMessage(text) {
    if (!this.hasAiChatBodyTarget) return;
    const div = document.createElement("div");
    div.className = "ai-chat-message ai-chat-message--error";
    div.innerHTML = `<div class="ai-chat-message__bubble">${this.escapeHtml(text)}</div>`;
    this.aiChatBodyTarget.appendChild(div);
    this.scrollChatToBottom();
  }

  renderNoticeMessage(msg) {
    const text = msg.notice || "Something went wrong. Please try again.";
    this.renderErrorMessage(text);
  }

  setLoading(loading) {
    if (!this.hasAiChatBodyTarget) return;
    const existing = this.aiChatBodyTarget.querySelector(".ai-chat-message--loading");
    if (loading && !existing) {
      const div = document.createElement("div");
      div.className = "ai-chat-message ai-chat-message--loading";
      div.innerHTML = `<div class="ai-chat-message__bubble"><span class="ai-chat-loading-dots"><span></span><span></span><span></span></span></div>`;
      this.aiChatBodyTarget.appendChild(div);
      this.scrollChatToBottom();
    } else if (!loading && existing) {
      existing.remove();
    }
  }

  setSendEnabled(enabled) {
    if (this.hasAiChatSendButtonTarget) {
      this.aiChatSendButtonTarget.disabled = !enabled;
    }
    if (this.hasAiChatInputTarget) {
      this.aiChatInputTarget.disabled = !enabled;
    }
  }

  scrollChatToBottom() {
    if (this.hasAiChatBodyTarget) {
      this.aiChatBodyTarget.scrollTop = this.aiChatBodyTarget.scrollHeight;
    }
  }

  escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  getSelectedTargetGroups() {
    if (!this.hasTargetsInputTarget) return [];
    try {
      const groups = JSON.parse(this.targetsInputTarget.dataset.targetGroups || "{}");
      return Object.keys(groups).filter((slug) => groups[slug]);
    } catch {
      return [];
    }
  }

  escapeAttr(str) {
    return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  // --- Chat History ---

  async fetchConversationHistory() {
    if (!this.hasAiChatHistoryListTarget || !this.conversationsIndexUrlValue) return null;

    try {
      const response = await fetch(this.conversationsIndexUrlValue, {
        headers: { "Accept": "application/json" },
      });
      if (!response.ok) return null;

      const conversations = await response.json();
      this.renderConversationHistory(conversations);
      return conversations;
    } catch {
      return null;
    }
  }

  renderConversationHistory(conversations) {
    if (!this.hasAiChatHistoryListTarget) return;

    if (!conversations.length) {
      this.aiChatHistoryListTarget.innerHTML = "";
      return;
    }

    this.aiChatHistoryListTarget.innerHTML = conversations.map((c) => {
      const isActive = String(c.id) === this.conversationIdValue;
      const title = this.escapeHtml(c.title || "Untitled conversation");
      const date = this.formatHistoryDate(c.updated_at);
      return `<div class="ai-chat-panel__history-item${isActive ? " ai-chat-panel__history-item--active" : ""}" data-conversation-id="${c.id}">
        <button class="ai-chat-panel__history-item-content" data-action="click->live-query#loadConversation" data-conversation-id="${c.id}">
          <span class="ai-chat-panel__history-item-title">${title}</span>
          <span class="ai-chat-panel__history-item-date">${date}</span>
        </button>
        <button class="ai-chat-panel__history-item-delete" data-action="click->live-query#deleteConversation" data-conversation-id="${c.id}" title="Delete conversation">
          &times;
        </button>
      </div>`;
    }).join("");
  }

  async loadConversation(event) {
    event.preventDefault();
    const id = event.currentTarget.dataset.conversationId;
    if (!id) return;
    await this.loadConversationById(id);
  }

  async loadConversationById(id) {
    this.conversationIdValue = String(id);

    const items = this.aiChatHistoryListTarget.querySelectorAll(".ai-chat-panel__history-item");
    items.forEach((item) => {
      item.classList.toggle("ai-chat-panel__history-item--active", item.dataset.conversationId === String(id));
    });

    this.aiChatBodyTarget.innerHTML = "";
    this.setLoading(true);

    try {
      const response = await fetch(`${this.conversationUrlValue}/${id}`, {
        headers: { "Accept": "application/json" },
      });

      this.setLoading(false);

      if (!response.ok) {
        this.renderErrorMessage("Could not load conversation.");
        return;
      }

      const data = await response.json();
      data.messages.forEach((m) => {
        if (m.role === "user") {
          this.renderUserMessage(m.content);
        } else {
          this.renderAssistantMessage(m.message);
        }
      });
    } catch {
      this.setLoading(false);
      this.renderErrorMessage("Could not load conversation.");
    }

    if (this.hasAiChatInputTarget) {
      this.aiChatInputTarget.focus();
    }
  }

  async startNewChat() {
    if (this.conversationIdValue) {
      await this.deactivateConversation();
    }

    this.conversationIdValue = "";
    this.aiChatBodyTarget.innerHTML = this._emptyStateHtml || "";
    await this.fetchConversationHistory();
    this.prependUntitledEntry();

    if (this.hasAiChatInputTarget) {
      this.aiChatInputTarget.focus();
    }
  }

  prependUntitledEntry() {
    if (!this.hasAiChatHistoryListTarget) return;
    if (this.aiChatHistoryListTarget.querySelector('[data-conversation-id="new"]')) return;

    const items = this.aiChatHistoryListTarget.querySelectorAll(".ai-chat-panel__history-item");
    items.forEach((item) => item.classList.remove("ai-chat-panel__history-item--active"));

    const placeholder = document.createElement("div");
    placeholder.className = "ai-chat-panel__history-item ai-chat-panel__history-item--active";
    placeholder.dataset.conversationId = "new";
    placeholder.innerHTML = `<button class="ai-chat-panel__history-item-content" data-action="click->live-query#startNewChat">
      <span class="ai-chat-panel__history-item-title">Untitled</span>
      <span class="ai-chat-panel__history-item-date">Just now</span>
    </button>`;

    this.aiChatHistoryListTarget.prepend(placeholder);
  }

  async deactivateConversation() {
    if (!this.conversationIdValue || !this.conversationUrlValue) return;

    try {
      await fetch(`${this.conversationUrlValue}/${this.conversationIdValue}/deactivate`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": Rails.csrfToken(),
        },
      });
    } catch {
      // Best-effort deactivation
    }
  }

  async deleteConversation(event) {
    event.preventDefault();
    event.stopPropagation();
    const id = event.currentTarget.dataset.conversationId;
    if (!id) return;

    try {
      await fetch(`${this.conversationUrlValue}/${id}`, {
        method: "DELETE",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": Rails.csrfToken(),
        },
      });
    } catch {
      return;
    }

    if (this.conversationIdValue === id) {
      this.conversationIdValue = "";
      this.aiChatBodyTarget.innerHTML = this._emptyStateHtml || "";
    }

    this.fetchConversationHistory();
  }

  formatHistoryDate(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;

    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;

    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 7) return `${diffDays}d ago`;

    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  }
}
